<template>
  <router-view />
</template>

<script>
export default {
  name: 'AuthApp'
}
</script>
